import useMount from '@src/utils/hooks/use-mount';

import { observable } from 'mobx';

class ReturnBtnStore {
  /**
   * 返回上一页
   */
  @observable
  onReturnClick = () => {
    window.history.back();
  };

  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    useMount(async () => {
      console.log('componentDidMount');
    });
  }
}

export default ReturnBtnStore;
